import script from "./FindMissingRelatableModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FindMissingRelatableModal.vue?vue&type=script&setup=true&lang=js"

import "./FindMissingRelatableModal.vue?vue&type=style&index=0&id=457512e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-457512e2"]])

export default __exports__